import { render, staticRenderFns } from "./MorphIcon.vue?vue&type=template&id=39801f7e&scoped=true&"
import script from "./MorphIcon.vue?vue&type=script&lang=js&"
export * from "./MorphIcon.vue?vue&type=script&lang=js&"
import style0 from "./MorphIcon.vue?vue&type=style&index=0&id=39801f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39801f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
